<template>
  <md-layout md-align="center" md-vertical-align="start">
    <md-card md-with-hover style="width: 80%;">
     <md-card-header>
    	<div class="md-title">Previous Experiments</div>
   	 	<div class="md-subhead"></div>
 	 </md-card-header>
    <md-card-content>
  	<md-table >
  	<md-table-header>
	    <md-table-row>
	      <md-table-head>#</md-table-head>
	      <md-table-head>Datetime</md-table-head>
	      <md-table-head >Experiment type</md-table-head>
	      <md-table-head ></md-table-head>
	      <md-table-head ></md-table-head>
	    </md-table-row>
	  </md-table-header>
	
	  <md-table-body>
	    <md-table-row v-for="(exp, index) in experiments " v-bind:key="index">
			
	      <md-table-cell>{{index+1}}</md-table-cell>
	      <md-table-cell>{{exp.started_at | moment("MMMM Do YYYY, HH:mm")}}</md-table-cell>
      	<md-table-cell>
      	  <span v-if="exp.exp_type==0">Like\Dislike</span>
      	  <span v-if="exp.exp_type==1">Human\GAN</span> 
          <span v-if="exp.exp_type==2">EMOTIV</span> 
      	</md-table-cell>
      	<md-table-cell>
      	  <router-link tag="a" :to="{ name: 'experiment_result', params: { id: exp.id }}" class="md-raised md-primary" style="width:60%">Details</router-link>
      	</md-table-cell>
      	<md-table-cell>
      	  <md-button class="md-fab md-mini open-button" @click="DeleteExperiment(exp.id)" >
           <md-icon >close</md-icon>
           
         </md-button>
      	
      	</md-table-cell>
      
    	</md-table-row>
  		</md-table-body>
	</md-table>
	</md-card-content>
    </md-card>
  </md-layout>
</template>

<script>
import _ from 'lodash'

export default {
	  name: 'experimentpassed',
	  props: [],

	  data () {
	    return {
	    	
	    }
	  },
	  beforeCreate() {
			this.$store.dispatch('getExperimentList') 
			
	  },

	  computed: {
		  
		  experiments() { 
			 let exp = this.$store.state.experiments_list			 
			 return _.orderBy(exp, 'started_at', 'desc')  
		},

	  },
	  methods: {
		  
		  DeleteExperiment(exp_id) {
			  this.$store.dispatch('deleteExperiment', exp_id)
		  }
   
	    }
	}

</script>

<style>


</style>


// WEBPACK FOOTER //
// ExperimentPassed.vue?58e00b2e